import { render, staticRenderFns } from "./order-info-modal.vue?vue&type=template&id=2bb7469d"
import script from "./order-info-modal.vue?vue&type=script&lang=js"
export * from "./order-info-modal.vue?vue&type=script&lang=js"
import style0 from "./order-info-modal.vue?vue&type=style&index=0&id=2bb7469d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports